__turbopack_context__.v({
  "className": "_9PFGEq_className",
  "variable": "_9PFGEq_variable",
});
